module.exports = __webpack_public_path__ + "media/assets/images/tour/4_Tour_1-8420a42a81c43228da41dc34d652f21a.jpg";